import { supabase } from "@/integrations/supabase/client";

/**
 * Registra uma ação administrativa no log
 */
export async function registrarLogAdmin({
  adminId,
  acao,
  tabela,
  registroId,
  dadosAntes = null,
  dadosDepois = null
}: {
  adminId: string;
  acao: string;
  tabela: string;
  registroId: string;
  dadosAntes?: any;
  dadosDepois?: any;
}) {
  // Use any cast to bypass type checking if the table isn't in generated types yet
  const { error } = await (supabase.from('log_admin' as any) as any).insert({
    admin_id: adminId,
    acao,
    tabela,
    registro_id: registroId,
    dados_antes: dadosAntes,
    dados_depois: dadosDepois
  });

  if (error) {
    console.error("Erro ao registrar log admin:", error);
  }
}
